import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Card, Typography, Alert, Space, Divider } from 'antd';
import { LockOutlined, UserOutlined, TagOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../../shared/contexts/AuthContext';
import { useLogin } from '../hooks/useLogin';
import { storageService } from '../../../shared/services/storage.service';

const { Title, Text } = Typography;

const LoginForm = () => {
  const { login, error: loginError, isLoading: loginLoading } = useLogin();
  const { user, role } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [localLoading, setLocalLoading] = useState(false);
  const version = process.env.REACT_APP_VERSION || 'unknown';

  const onFinish = async (values: { userName: string; password: string }) => {
    setLocalLoading(true);
    const success = await login(values.userName, values.password);
    if (success) {
      // Navigate to the appropriate page after successful login
      const from = location.state?.from?.pathname || (role === 'superadmin' ? '/app/users' : '/app');
      navigate(from, { replace: true });
    }
    setLocalLoading(false);
  };

  useEffect(() => {
    // Clear prev session saved filters etc.
    storageService.clearSessionData();
    // If user is already logged in and on the login page, redirect to app
    if (user && location.pathname === '/login') {
      const from = location.state?.from?.pathname || '/app';
      console.log('User already logged in, redirecting to', from);
      navigate(from, { replace: true });
    }
  }, [user, location.pathname, role, navigate]);


  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '16px',
      backgroundColor: '#f0f2f5'
    }}>
      <Card style={{
        width: '100%',
        maxWidth: 400,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <Title level={2} style={{ textAlign: 'center', marginBottom: 8 }}>Promoter App</Title>
        <Title level={4} style={{ textAlign: 'center', marginBottom: 24, fontWeight: 'normal', color: '#8c8c8c' }}>Вход</Title>
        {loginError && (
          <Alert
            message="Ошибка"
            description={loginError}
            type="error"
            showIcon
            style={{ marginBottom: 24 }}
          />
        )}
        <Form
          name="login"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <Form.Item
            name="userName"
            rules={[{ required: true, message: 'Пожалуйста, введите имя пользователя!' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="Имя пользователя" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Пожалуйста, введите пароль!' }]}
          >
            <Input
              prefix={<LockOutlined />}
              type="password"
              placeholder="Пароль"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loginLoading || localLoading}>
              Войти
            </Button>
          </Form.Item>
        </Form>

        <Divider style={{ margin: '12px 0' }} />
        <div style={{ textAlign: 'center' }}>
          <Space>
            <TagOutlined style={{ color: '#1890ff' }} />
            <Text type="secondary" style={{ fontSize: '12px' }}>
              Версия: {version}
            </Text>
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default LoginForm;
